import { configureStore } from '@reduxjs/toolkit'
import UserSlice from './slice/UserSlice';
import TrainingSlice from './slice/TrainingSlice'; 

export default configureStore({
  reducer: {
      user: UserSlice,
      training: TrainingSlice
  }
})